import { createStore } from 'vuex'

import { csv } from "d3-fetch";

const gedrag = {
	Nee:"Nee",
	Vermijd:"Ik kom er niet",
	Ophalen:"Ik vraag iemand om mij op te halen",
	Vervoer_wijziging:"Ik neem ander vervoer",
	Kleren:"Ik draag andere kleren",
	Donker_aanpassing:"Ik ga daar niet in het donker heen",
	Wapen:"Ik bescherm mezelf met een wapen",
	Alcohol:"Ik drink geen of minder alcohol",
	Drankje:"Ik pas goed op dat niemand iets in mijn drankje gooit",
	Groep:"Ik ga altijd met een groepje mensen",
	Live_Locatie:"Ik deel mijn live-locatie via de telefoon",
	Informeer_vrienden:"Ik laat vrienden weten waar ik ben",
	Omlopen:"Ik rijd/loop/fiets om",
	Bellen:"Ik doe alsof ik iemand bel",
	Eerder_huis:"Ik ga eerder naar huis dan ik wil",
	Anders:"Anders"
}

const labelReden = {
	Mij: "Er is mij hier iets overkomen",
	Iemand_anders: "Ik weet dat iemand anders hier iets is overkomen",
	Omgeving: "De omgeving vind ik eng; mij kan hier makkelijk iets overkomen"
}

const labelTijdstip= {
	Overdag: "Vooral overdag",
	Donker: "Vooral als het donker is",
	Maakt_niet_uit: "Tijdstip maakt niet uit"
}

export default createStore({
	state: {
		data: {},
		locations: undefined,
		quotes: [],
		featured:undefined,
		featuredIndex: undefined,
		featuredMarker: undefined,
		labelsGedrag: gedrag,
		labelsReden: labelReden,
		labelsTijdstip: labelTijdstip
	},
	mutations: {
		SAVE_DATA(state, payload) {
			state.data = payload;
		},

		SAVE_MARKERS(state, payload) {
			state.locations = payload;
		},

		SAVE_QUOTES(state, payload) {
			let quotesFilter = payload.filter(d => d.Longitude);
			
			quotesFilter.sort((a, b) => a.GM_NAAM.localeCompare(b.GM_NAAM));

			let quotesIndexed = quotesFilter.map((d, index) => {
				d.index = index + 1;
				return d;
			});

			state.quotes = quotesIndexed;
		},

		UPDATE_FEATURED(state, payload) {
			state.featured = payload;
		},

		UPDATE_SWIPER(state, index) {
			state.featuredIndex = index;
		},

		UPDATE_MARKER(state, payload) {
			if(state.featuredMarker) {
				state.featuredMarker.active = false;
			}

			payload.active = true;

			state.featuredMarker = payload;
		}
	},
	getters: {
		locations: (state) => state['locations'],
		quotes: (state) => state['quotes'],
		featured: (state) => state['featured'],
		featuredIndex: (state) => state['featuredIndex'],
		maxIndex: (state) => state['quotes'].length + 1,
		featuredMarker: (state) => state['featuredMarker'],
		labelsGedrag: (state) => state['labelsGedrag'],
		labelsReden: (state) => state['labelsReden'],
		labelTijdstip: (state) => state['labelsTijdstip'],
	},
	actions: {
		loadMarkers({ commit, state }) {
			return new Promise((resolve, reject) => {

				csv(process.env.VUE_APP_PATH + '/assets/locaties.csv')
				.then((result) => {						
						commit('SAVE_MARKERS', result);
						resolve()
					})
					.catch((error) => {
						reject()
						throw new Error(`API ${error}`)
					})
			})

		},

		loadQuotes({ commit, state }) {
			return new Promise((resolve, reject) => {

				csv(process.env.VUE_APP_PATH + '/assets/quotes.csv')
				.then((result) => {						
						// console.log('store data hook', result.data)
						commit('SAVE_QUOTES', result);
						resolve()
					})
					.catch((error) => {
						reject()
						throw new Error(`API ${error}`)
					})
			})
		},

		setQuotes({ commit, state } ) {
			commit('SET_QUOTES');
		},

		updateFeatured({ commit, state }, payload) {
			commit('UPDATE_FEATURED', payload)
			commit('UPDATE_SWIPER', payload.index)
		},

		updateMarker({ commit, state }, payload) {
			commit('UPDATE_MARKER', payload)
		},

		updateSwiper({ commit, state }, index) {
			commit('UPDATE_SWIPER', index)
			commit('UPDATE_FEATURED', state.quotes[index - 1])
		}
	},
	modules: {}
})
